import axios from 'axios';
import { ChainId, NATIVE_ADDRESS, NATIVE_SOL, WRAPPED_SOL, ZERO_ADDRESS } from '../config/networks';
import { fetchTokenPriceDefined } from './definedTokenUsdPrice';
import { WrappedNativeTokens } from '../../types/quoting-engine/wrappedNativeTokens';
/**
 * Retrieves the USD price of a token on a specific chain.
 * @param chainId - The ID of the chain.
 * @param tokenAddress - The address of the token.
 * @returns A promise that resolves to the USD price of the token.
 */
export async function getTokenUSDPrice(chainId, tokenAddress) {
    var _a;
    const isSui = chainId === ChainId.SUI;
    if (!isSui) {
        const priceAddress = tokenAddress == NATIVE_SOL ? WRAPPED_SOL : ((tokenAddress === null || tokenAddress === void 0 ? void 0 : tokenAddress.toLowerCase()) == (NATIVE_ADDRESS === null || NATIVE_ADDRESS === void 0 ? void 0 : NATIVE_ADDRESS.toLowerCase()) || tokenAddress == ZERO_ADDRESS) ? WrappedNativeTokens.get(chainId) : tokenAddress;
        const definedPrice = await fetchTokenPriceDefined(priceAddress, chainId.toString());
        const price = definedPrice.data.getTokenPrices[0].priceUsd;
        return price;
    }
    else {
        const url = 'https://aftermath.finance/api/price-info';
        const payload = { coins: [tokenAddress] };
        try {
            console.log('Sending request with payload:', JSON.stringify(payload, null, 2));
            const response = await axios.post(url, payload, {
                headers: { accept: 'application/json' },
            });
            console.log(`SUI price response`, response.data[tokenAddress].price);
            return response.data[tokenAddress].price;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                console.error('Axios error:', ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) || error.message);
            }
            else {
                console.error('Error fetching token price:', error);
            }
            return 0;
        }
    }
}
